import { createSelector } from "reselect";

export const selectUser = state => state.oidc.user;

export const selectUserIsLoading = state => state.oidc.isLoadingUser;

export const selectUserIsLoggedIn = createSelector(
  selectUser,
  user => (user ? !user.expired : false)
);

export const selectUserToken = createSelector(
  selectUser,
  user => user.id_token
);

export const selectAccessToken = createSelector(
  selectUser,
  user => user && user.access_token
);

export const selectUserId = createSelector(
  selectUser,
  user => user && user.profile && user.profile.sub
);

export const selectUserProfile = createSelector(selectUser, user => {
  try {
    return JSON.parse(user.profile["user.profile"]);
  } catch (err) {
    return {};
  }
});

export const selectUserName = createSelector(
  selectUserProfile,
  selectUserId,
  (profile, userId) => profile.Name || userId
);

export const selectUserEmail = createSelector(
  selectUserProfile,
  profile => profile.Email
);

export const selectUserEntity = createSelector(
  selectUser,
  user => user && user.profile && user.profile["user.entity"]
);

export const selectRoles = createSelector(
  selectUserEntity,
  userEntity =>
    userEntity ? userEntity.map(item => JSON.parse(item).Role) : []
);
